export const f2mServicesSlugs: any = {
    'car-sharing': {
        fr: 'autopartage',
        de: 'free-floating-car-sharing',
        en: 'free-floating-car-sharing',
        'es-ES': 'free-floating-car-sharing',
        'es-AR': 'free-floating-car-sharing'
    },
    'charge-my-car': {
        fr: 'recharger-ma-voiture',
        en: 'charge-my-car',
        'es-ES': 'charge-my-car',
        it: 'charge-my-car',
        'de-DE': 'charge-my-car',
        'pt-PT': 'charge-my-car',
        nl: 'charge-my-car'
    },
    'car-rental': {
        'en-GB': 'car-rental',
        'en-US': 'car-rental',
        'bg': 'наемане-на-кола',
        'cs': 'půjčení-auta',
        'da': 'biludlejning',
        'de': 'autovermietung',
        'el': 'ενοικίαση-αυτοκινήτου',
        'es-ES': 'alquiler-de-coches',
        'es-AR': 'alquiler-de-coches',
        'fi': 'vuokraa-auto',
        'fr': 'reserver-une-voiture',
        'hr': 'najam-automobila',
        'hu': 'autoberles',
        'it': 'affitto-auto',
        'ko': '자동차-임대',
        'lv': 'autonoma',
        'nb': 'lei-en-bil',
        'nl': 'autoverhuur',
        'pl': 'wynajem-samochodu',
        'pt': 'aluguer-de-carro',
        'ro': 'inchiriere-masina',
        'ru': 'аренда-автомобилей',
        'sv': 'biluthyrning',
        'tr': 'araba-kiralama',
        'uk': 'орендувати-автомобіль',
        'vi': 'thuê-ô-tô',
        'zh': '汽车出租',
        'zh-TW': '汽車出租'
    },
    'parking-lot': {
        'fr': 'places-de-parking',
        'en': 'parking-lot',
        'es-AR': 'parking-lot',
        'es-ES': 'parking-lot',
        'it': 'parking-lot',
        'de': 'parking-lot',
        'pt': 'parking-lot',
        'nl': 'parking-lote'
    },
    'car-on-demand': {
        'fr-FR': 'car-on-demand',
        'en-US': 'car-on-demand',
        'en-GB': 'car-on-demand',
        'es-ES': 'car-on-demand',
        'de-DE': 'car-on-demand',
        'pt-PT': 'car-on-demand',
        'it-IT': 'car-on-demand'
    },
    'business-solutions': {
        fr: 'solutions-business',
        '*': 'business-solutions'
    }
}
export const f2mSlugs: any = {
    'press': {
        'fr-FR': 'presse',
        'fr-BE': 'presse',
        'fr-LU': 'presse',
        'es-ES': 'prensa',
        'en-GB': 'press',
        'en-US': 'press',
        'it-IT': 'comunicato-stampa',
        'de-DE': 'pressemitteilung',
        'pt-PT': 'pressa'
    },
    'blog': {
        '*': 'blog'
    },
    "support": {
        '*': 'support'
    },
    'login': {
        fr: 'connexion',
        '*': 'login'
    },
    'logout': {
        fr: 'deconnexion',
        '*': 'logout'
    },
    'legal': {
        de: "rechtlicher-hinweis",
        el: "nομικές-πληροφορίες",
        en:"legal-information",
        es:"aviso-legal-y-terminos",
        fr:"informations-legales",
        "fr-BE": "informations-legales",
        it:"informazioni-legali",
        nl:"legale-informatie",
        pt:"notas-legais",
        sl:"pravne-informacije"
    }
}
